import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import TrackingLink from 'Layout/NavBar/MegaMenu/Categories/TrackingLink';

export default function ThemesLinks({ setMegaMenuTab }) {
  return (
    <ul className="CategoriesMegaMenu__linksContainer mb-4" role="menu">
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--title">
        <Link to="/categories" id="categories-themes" onClick={() => setMegaMenuTab('')}>
          <FormattedMessage id="themes-links.link.themes" defaultMessage="Themes" />
        </Link>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/anime" id="categories-anime" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="themes-links.link.anime" defaultMessage="Anime" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/family-friendly" id="categories-familyfriendly" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="themes-links.link.family-friendly" defaultMessage="Family Friendly" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/horror" id="categories-horror" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="themes-links.link.horror" defaultMessage="Horror" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/management" id="categories-management" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="themes-links.link.management" defaultMessage="Management" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/sci-fi" id="categories-scifi" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="themes-links.link.sci-fi" defaultMessage="Sci-fi" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/survival" id="categories-survival" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="themes-links.link.survival" defaultMessage="Survival" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/zombies" id="categories-zombies" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="themes-links.link.zombies" defaultMessage="Zombies" />
        </TrackingLink>
      </li>
    </ul>
  );
}

ThemesLinks.propTypes = {
  setMegaMenuTab: PropTypes.func,
};

ThemesLinks.defaultProps = {
  setMegaMenuTab: () => { },
};
